import WithRender from "../../templates/base/inputCustomFormat.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getCustomFormats"])
  },
  props: ["nrItems"]
});
